import { CommonModule } from '@angular/common';
import { FormInlineErrorComponent } from './form-inline-error.component';
import { NgModule } from '@angular/core';
import { SharedComponentsModule } from '../../modules/sharedComponentsModule';


@NgModule({
    declarations: [
        FormInlineErrorComponent,
    ],
    imports: [
        CommonModule,
        SharedComponentsModule
    ],
    exports: [
        FormInlineErrorComponent,
    ]
})
export class FormInlineErrorModule { }
